export default __webpack_public_path__ + "static/media/moon.62001a1c.svg";